import h from './helpers.js'

const overlaySelector = ".js-overlay"
const overlayShowClass = "overlay--show"

const close = function(e) {
	e?.preventDefault()
	const overlay = this.closest(overlaySelector)
	overlay.classList.remove(overlayShowClass)
}

const overlay = () => {
	
	h.on('click', '.js-closeoverlay', close)
	document.addEventListener('keydown', e => {
		if (e.key === 'Escape' || e.key === 'Esc') {
			document.querySelectorAll(overlaySelector).forEach(overlay => {
				overlay.classList.remove(overlayShowClass)
			})
		}
	})
	
}

export default overlay
